export const mediaFiles = {
  _title: 'Fichiers media',
  drive: 'Google Drive',
  youtubeFootprint: 'Empreinte de protection',
  youtubeVideo: 'Vidéo YT',
  clickupLink: 'ClickUp',
  diffusionZone: 'Zone de diffusion',
  coldStorage: 'Stockage longue durée',
}
